import { Box, Button, Grid, Skeleton, Theme, Typography, useTheme } from "@mui/material";
import { FrequencyArray, InvestmentFundType } from "../../../redux-store/types/api-types";
import { MandatesListResBody } from "../../../redux-store/types/investorProfile";
import { useHistory } from "react-router";
import { useState } from "react";
import { MpowerValidationType } from "../types";
import { CustomeBlueDatePicker, CustomeBlueDropDown, CustomeNumberInput, PickUpInput } from "./FromInput";
import AddBankModal from "../common/AddBankModal";
import dayjs from "../../../utils/dayjs";
import { WEEKLYDAYS } from "../../../utils/constant";
import { FormikValues, useFormikContext } from '../../../lib/formik/Formik';
import {
    BankDetails, GetOrderEntryBanksListResponseBody
} from "../../../redux-store/types/orderManagement";
import { MandateInfoBox, MandateSelectionDialog } from "./Mandate";
import MFCheckbox from "../../../lib/formik/Checkbox";
import { InfoIconOutlined } from "../../../assets/SvgIcons";
import { findNextValidDate, getDailyFreqInstallmentsMsg, addWorkingDays } from "../../../utils/utilityFunctions";

interface SIPProps {
    isLoading: boolean;
    id: string | number
    // validation: ValidationInvestment
    clientCode?: string
    activeMandateList: Array<MandatesListResBody>
    data: InvestmentFundType
    valueIdentifier: string
    isSubmitting: boolean;
    bankAccountList?: GetOrderEntryBanksListResponseBody;
}

export const handleDateValidation = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs) => {

    if (ArrayOfDate?.length === 0) {
        return false
    }
    if (typeof ArrayOfDate?.[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate?.[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
    }
    return false
}



const Sip = (props: SIPProps) => {
    const { isLoading, id, data, clientCode, activeMandateList, valueIdentifier, isSubmitting, bankAccountList } = props;
    const { palette } = useTheme();
    const history = useHistory();
    const { validataion: validation, folios, frequencies = [], sipAllowed = "Y", sip } = data
    const { pathname } = history.location

    const { values, setFieldValue } = useFormikContext<FormikValues>()

    const [openBankModal, setOpenBankModal] = useState(false);
    const [isMandateSelectDialogOpen, setMandateSelectDialogOpen] = useState<boolean>(false)

    const getArrayFrequency = data?.frequencies?.filter((item: FrequencyArray) => item?.tranasactionType === "SIP" && item?.frequency)
    const getValidation = data?.validations?.filter((item: MpowerValidationType) => item?.transactionType === "SIP" && item?.frequency === sip?.periods)[0]



    function drowDownDateFormate(array: Array<MandatesListResBody>) {
        return array?.map((item: MandatesListResBody) => {
            return {
                label: item?.displayText,
                value: item?.mandateId
            }
        })
    }

    const frequencyArray = data?.frequencies?.filter(item => item.frequency && item.tranasactionType === 'SIP')
    const Daily = data?.validations?.filter((item) => item?.frequency === 'DAILY' && item?.transactionType === 'SIP')?.[0]
    const Weekly = data?.validations?.filter((item) => item?.frequency === 'WEEKLY' && item?.transactionType === 'SIP')?.[0]
    const WeeklyDays = data?.validations?.filter((item) => item?.frequency === 'WEEKLYDAYS' && item?.transactionType === 'SIP')?.[0]
    const Monthly = data?.validations?.filter((item) => item?.frequency === 'MONTHLY' && item?.transactionType === 'SIP')?.[0]
    const Quarterly = data?.validations?.filter((item) => item?.frequency === 'QUARTERLY' && item?.transactionType === 'SIP')?.[0]
    const Yearly = data?.validations?.filter((item) => item?.frequency === 'YEARLY' && item?.transactionType === 'SIP')?.[0]

    const sipMinAmount = (key = 'minimumInstallmentAmount' as keyof MpowerValidationType, frequency: string) => {

        if (frequency === 'WEEKLY') {
            return Weekly?.[key]
        } else if (frequency === 'MONTHLY') {
            return Monthly?.[key]
        } else if (frequency === 'QUARTERLY') {
            return Quarterly?.[key]
        } else if (frequency === 'YEARLY') {
            return Yearly?.[key]
        } else if (frequency === 'DAILY') {
            return Daily?.[key]
        } else if (frequency === 'WEEKLYDAYS') {
            return WeeklyDays?.[key]
        } else {
            return 0
        }
    }

    const handleOpenMandateSelectDialog = () => {
        setMandateSelectDialogOpen(true)
    }

    const handleCloseMandateSelectDialog = () => {
        setMandateSelectDialogOpen(false)
    }

    const handleMandateSelection = (mandateId: string) => {
        setFieldValue(`fund.${id}.sip.mandate`, mandateId)
        setMandateSelectDialogOpen(false)
    }

    const handleFirstOrderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue(`fund.${id}.sip.firstOrder`, event.target.checked);
        setFieldValue(`fund.${id}.sip.sipDate`, findNextValidDate(getValidation?.investmentDates ?? [], event.target.checked));
    }

    return (
        <>
            {activeMandateList.length === 0 && <>
                <Box m={'auto auto'}>
                    <Typography
                        variant="h6"
                        color={palette.error[500]}
                        sx={{ textAlign: 'center', m: 4 }}
                    >
                        No active mandates are present. Please wait until they are activated.
                    </Typography>
                </Box>
            </>}
            {(sipAllowed === 'N' || sipAllowed === null) && <>
                <Box m={'auto auto'}>
                    <Typography
                        variant="h6"
                        color={palette.error[500]}
                        sx={{ textAlign: 'center', m: 4 }}
                    >
                        SIP purchase is not allowed.
                    </Typography>
                </Box>
            </>}

            {(sipAllowed === 'Y' && activeMandateList.length !== 0) &&
                <>
                    <Grid container spacing={2} rowGap={2}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <PickUpInput
                                disabled={isSubmitting}
                                inputType="number"
                                isLoading={isLoading}
                                name={`fund[${id}].sip.sipamount`}
                                minValue={sipMinAmount('minimumInstallmentAmount', values?.fund[id]?.sip?.periods)}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeBlueDropDown
                                disabled={isSubmitting}
                                name={`fund[${id}].sip.periods`}
                                isLoading={isLoading}
                                label='Frequency'
                                list={[...getArrayFrequency]?.map((item: FrequencyArray) => {
                                    return {
                                        label: item?.frequency || '',
                                        value: item?.frequency || ''
                                    }
                                })}
                            />
                        </Grid>
                        {(isLoading) && (
                            <Skeleton
                                animation="wave"
                                width="100%"
                                sx={{
                                    padding: '15px',
                                    borderRadius: 2,
                                    ml: 2,
                                    mt: 1,
                                }}
                            />
                        )}
                        {!(isLoading) && (
                            <Box
                                sx={{
                                    ml: 2,
                                    mt: 1,
                                    width: '100%',
                                    padding: '4px 0px 4px 15px',
                                    backgroundColor: palette.primary[50],
                                    borderRadius: 2
                                }}
                            >
                                <MFCheckbox
                                    name={`fund[${id}].sip.firstOrder`}
                                    label='Pay 1st Installment Today'
                                    disabled={isSubmitting}
                                    onChange={handleFirstOrderChange}
                                />
                            </Box>
                        )}
                        {(values?.fund?.[id]?.sip?.periods !== 'DAILY') && (
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeNumberInput
                                    isLoading={isLoading}
                                    disable={isSubmitting}
                                    textType="number"
                                    label='No. of Installments'
                                    name={`fund[${id}].sip.installments`}
                                    minValue={sipMinAmount('minimumInstallments', values?.fund[id]?.sip?.periods)}
                                    minlabel={`Min. ${sipMinAmount('minimumInstallments', values?.fund[id]?.sip?.periods)}`}
                                    removeIcons={true}
                                />
                            </Grid>
                        )}
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeBlueDatePicker
                                name={`fund[${id}].sip.sipDate`}
                                label={(values?.fund?.[id]?.sip?.periods === 'DAILY') ? "SIP Start Date" : values?.fund?.[id]?.sip?.firstOrder ? "Next SIP Date" : "SIP Date"}
                                isLoading={isLoading}
                                disabled={isSubmitting}
                                disablePast={true}
                                // disableDateList={getValidation?.investmentDates}
                                // For non-first orders, additionally disable weekends (Sat/Sun) so only
                                // working days (Mon–Fri) can be selected, matching findNextValidDate.
                                shouldDisableDate={(date: dayjs.Dayjs) =>
                                    handleDateValidation(getValidation?.investmentDates, date) ||
                                    (!values?.fund?.[id]?.sip?.firstOrder && (dayjs(date).day() === 0 || dayjs(date).day() === 6))
                                }
                                // For T+1 date
                                // minDate={dayjs().add(1, 'day')}
                                // For non-first orders: earliest date is T+3 working days.
                                // addWorkingDays skips weekends so the result is always a Mon–Fri.
                                minDate={!values?.fund?.[id]?.sip?.firstOrder ? addWorkingDays(dayjs(), 3) : dayjs().add(31, 'days')}
                            />
                        </Grid>
                        {(values?.fund?.[id]?.sip?.periods === 'DAILY') && (
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeBlueDatePicker
                                    name={`fund[${id}].sip.sipEndDate`}
                                    isLoading={isLoading}
                                    disablePast
                                    disabled={values?.fund?.[id]?.sip.sipDate === '' || isSubmitting}
                                    label="SIP End Date"
                                    shouldDisableDate={(date: dayjs.Dayjs) => dayjs(date).isBefore(dayjs(values?.fund?.[id]?.sip?.sipDate))}
                                />
                            </Grid>
                        )}
                        {(!isLoading && (values?.fund?.[id]?.sip?.periods === 'DAILY')) && (
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    columnGap: "5px",
                                    marginLeft: "16px"
                                }}>
                                <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
                                    <InfoIconOutlined />
                                </Box>
                                <Typography
                                    variant='subtitle_600'
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.grey[500]
                                    })}
                                >
                                    {getDailyFreqInstallmentsMsg(Daily?.minimumInstallments ?? 0)}
                                </Typography>
                            </Box>
                        )}
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            {/* <CustomeBlueDropDown
                                isLoading={isLoading}
                                disabled={isSubmitting}
                                label="Mandate"
                                name={`fund[${id}].sip.mandate`}
                                list={drowDownDateFormate(activeMandateList)}
                            /> */}
                            <MandateInfoBox
                                isLoading={isLoading}
                                isDisabled={isSubmitting}
                                activeMandateList={activeMandateList}
                                id={id}
                            />
                            {/* <Typography
                                component={'a'}
                                variant="subtitle_500"
                                color={palette.primary[500]}
                                onClick={() => setOpenBankModal(true)}
                                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                fontSize={{ lg: '16px', md: '16px', sm: '14px', xs: '14px' }}
                            >
                                Create New Mandate
                            </Typography> */}
                            {!isLoading && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: 'center',
                                        flexWrap: "wrap",
                                        mt: 1
                                    }}
                                >
                                    <Button
                                        sx={(theme: Theme) => ({
                                            ...theme.typography.body_500,
                                            color: theme.palette.primary[500],
                                            textDecoration: 'underline',
                                            padding: 0,
                                            ':hover': {
                                                backgroundColor: "transparent"
                                            }
                                        })}
                                        onClick={() => setOpenBankModal(true)}
                                        disabled={isSubmitting}
                                    >
                                        Create New Mandate
                                    </Button>
                                    <Button
                                        sx={(theme: Theme) => ({
                                            ...theme.typography.body_500,
                                            color: theme.palette.primary[500],
                                            textDecoration: 'underline',
                                            padding: 0,
                                            ':hover': {
                                                backgroundColor: "transparent"
                                            }
                                        })}
                                        onClick={handleOpenMandateSelectDialog}
                                        disabled={isSubmitting}
                                    >
                                        Select Mandate
                                    </Button>
                                </Box>
                            )}
                        </Grid>
                        {pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' && (
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeBlueDropDown
                                    isLoading={isLoading}
                                    disabled={isSubmitting}
                                    label="Select Folio"
                                    name={`fund[${id}].sip.sipFolio`}
                                    list={folios?.availableFolios?.map((item) => ({ label: item, value: item }))}
                                />
                            </Grid>
                        )}
                    </Grid>
                    {openBankModal && (
                        <AddBankModal
                            {...{
                                handleClose: () => setOpenBankModal(false),
                                open: openBankModal,
                                setOpen: setOpenBankModal,
                                title: 'Add New Bank Mandate',
                                clientCode: clientCode,
                            }}
                        />
                    )}
                </>
            }
            {
                isMandateSelectDialogOpen && (
                    <MandateSelectionDialog
                        open={isMandateSelectDialogOpen}
                        onClose={handleCloseMandateSelectDialog}
                        currentMandateId={values?.fund?.[id]?.sip?.mandate ?? ""}
                        mandateList={activeMandateList}
                        handleMandateSelection={handleMandateSelection}
                    />
                )
            }
        </>
    );
};

export default Sip